module.exports = __webpack_public_path__ + "img/people3.2b04bd8f.png";